export default __webpack_public_path__ + "media/images/manual/joanr/14-af97bdf500118ef4bbd3c07a2ce383aa.png";